export interface Auth0Tenant {
  readonly domain: string;
  readonly clientId: string;
}

/**
 * How the app signs people in: through the Centro portal's Auth0 application
 * (ai-docs ADR-0001, "Access"), or, in a local dev server, with a local session.
 */
export type SignIn =
  | { readonly kind: "auth0"; readonly tenant: Auth0Tenant }
  | { readonly kind: "localDev" };

// The deployed hosts and the portal's Auth0 application in each. Domains and client
// ids from ai-docs golden-ui/deploy/envs/{bronze,preprod}/values.yaml.
const TENANTS_BY_HOST: Readonly<Record<string, Auth0Tenant>> = {
  "bronze.centrobenefits.io": {
    domain: "centro-bp-qat.us.auth0.com",
    clientId: "zi2AJR2Lh2DLA6PGhhBluprEhX9Tnhu1",
  },
  "golden.centrobenefits.io": {
    domain: "centro-bp-preprod.us.auth0.com",
    clientId: "QbFAHidJ7FUBLHsOxbUJixxobp9EYl9L",
  },
};

export const signInFor = (hostname: string, isDevServer: boolean): SignIn => {
  const tenant = TENANTS_BY_HOST[hostname];
  if (tenant) return { kind: "auth0", tenant };
  if (isDevServer) return { kind: "localDev" };
  throw new Error(`golden-ui has no sign-in configured for ${hostname}`);
};

export const signIn: SignIn = signInFor(
  window.location.hostname,
  import.meta.env.DEV,
);

/** The single role the golden set admits (ai-docs ADR-0001, "Access"). */
export const RUMI_TESTER_ROLE = "rumi-tester";
